(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-card-description-expandable"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('expandable-card-description')) {
    let descriptionSequence = 0;
    customElements.define('expandable-card-description', class extends HTMLElement {
      connectedCallback() {
        if (this._connected) return;
        this._connected = true;
        this.textElement = this.querySelector('.ecd__text');
        this.button = this.querySelector('.ecd__toggle');
        if (!this.textElement || !this.button) return;
        this.textElement.id = 'expandable-card-description-' + (++descriptionSequence);
        this.button.setAttribute('aria-controls', this.textElement.id);
        this.setAttribute('data-ready', '');
        this.onClick = (event) => {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          this.toggleAttribute('data-expanded');
          this.updateLabels();
        };
        this.stopCardPointer = (event) => event.stopPropagation();

        // Bind directly to the button so the card's navigation handler cannot
        // turn an expand/collapse click into a product-page navigation.
        this.button.addEventListener('pointerdown', this.stopCardPointer);
        this.button.addEventListener('click', this.onClick);
        this.schedule = () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.measure());
        };
        if ('ResizeObserver' in window) {
          this.observer = new ResizeObserver(this.schedule);
          this.observer.observe(this);
        }
        window.addEventListener('resize', this.schedule);
        if (document.fonts) document.fonts.ready.then(() => {
          if (this.isConnected) this.schedule();
        });
        this.schedule();
      }
      updateLabels() {
        const expanded = this.hasAttribute('data-expanded');
        this.button.setAttribute('aria-expanded', String(expanded));
        this.querySelector('.ecd__more').hidden = expanded;
        this.querySelector('.ecd__less').hidden = !expanded;
      }
      measure() {
        if (!this.isConnected || !this.textElement.getBoundingClientRect().width) return;
        // Measure full natural height at the current width, even while expanded.
        const clone = this.textElement.cloneNode(true);
        clone.removeAttribute('id');
        clone.setAttribute('aria-hidden', 'true');
        clone.style.cssText = 'position:absolute!important;visibility:hidden!important;pointer-events:none!important;display:block!important;-webkit-line-clamp:unset!important;line-clamp:unset!important;inset:0 auto auto 0!important;width:' + this.textElement.getBoundingClientRect().width + 'px!important;';
        this.appendChild(clone);
        const css = getComputedStyle(this.textElement);
        const variable = matchMedia('(max-width: 749px)').matches ? '--ecd-lines-m' : '--ecd-lines-d';
        const lines = Number(getComputedStyle(this).getPropertyValue(variable));
        const overflowing = clone.getBoundingClientRect().height > parseFloat(css.lineHeight) * lines + 1;
        clone.remove();
        this.button.hidden = !overflowing;
        if (!overflowing) this.removeAttribute('data-expanded');
        this.updateLabels();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
        window.removeEventListener('resize', this.schedule);
        this.button?.removeEventListener('pointerdown', this.stopCardPointer);
        this.button?.removeEventListener('click', this.onClick);
        this._connected = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
